import React, { useState } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import { useContext } from 'components/Managers/Members/Context';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import infoAlert from 'components/new_ui/Alerts/alert';
import useTemplates from 'components/Common/Templates/Hooks/useTemplates';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Statistics from './Statistics';

export default function Index() {
  const { state: { finchOptions, enterpriseId }, actions } = useContext();
  const [loading, setLoading] = useState(false);

  const stateLocation = useLocation();
  const stats = stateLocation.state?.statistics;

  const members = stateLocation.state?.members;
  const templates = useTemplates(enterpriseId);

  const cpaTemplate = templates && templates.find((item) => item.attributes.type === 'CPA');

  const confirmCpaAssign = () => {
    confirmAlert({
      title: 'Confirm Assessment Assignment',
      text: `Are you sure you want to assign Talent Assessments to all selected members? 
      This action will assign the assessment to each team member you’ve added or selected.`,
      confirmButtonText: 'Assign',
    }, () => {
      setLoading(true);
      actions.assignMultiCpa(cpaTemplate.id, members.map((item) => item.email), (result) => {
        if (result.status) {
          document.location.href = routes.managers.invite.index;
        } else {
          setLoading(false);
          infoAlert({
            title: 'Assign Members',
            text: result.message,
          });
        }
      });
    });
  };

  return (
    <>
      <StepTab total={3} current={3} />

      <div className="content">
        <Row>
          <Col lg={{ span: 6, order: 'last' }}>
            <div className="bg-photo bg-managers-members-success-photo" />
          </Col>

          <Col lg={{ span: 6, order: 'first' }}>
            <div className="py-4 px-sm-4 p-xxl-5">
              <h1 className="mb-5">Congratulations!</h1>

              {finchOptions.synchImport ? (
                <p>Great News! Your members have been synchronized.</p>
              ) : (
                <p>Great news! Your new members have been added to the system.</p>
              )}

              {stats && <Statistics data={stats} />}

              <p>
                Congratulations on successfully importing your employee information
                to LeggUP! Now, it&apos;s time to assign a program to each member.
                Once assigned, you can invite them to start their programs
                and begin their Career Wellbeing journey.
              </p>

              {templates === null && (
                <LoadingPlaceholder text="Loading..." className="my-4" />
              )}

              {cpaTemplate && members && members.length > 0 && (
                <Button
                  onClick={confirmCpaAssign}
                  style={{ width: '350px' }}
                >
                  {loading && (
                  <LoadingPlaceholder placement="inline" text=" " />
                  )}
                  Invite To Take Assessment
                </Button>
              )}

              {templates && (
                <a
                  href={routes.managers.programs.index}
                  className="btn btn-primary mt-4"
                  style={{ width: '350px' }}
                >
                  Assign Talent Insurance Program
                </a>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <ScrollRestoration />
    </>
  );
}
